export default __webpack_public_path__ + "static/media/166.8e445cff.png";